<h2 i18n="@@requestDemoTitle|Заявки пользователей">User requests</h2>

<resto-table-grid
  restoTableGridStretchByHeight
  [restoThrottleTime]="300"
  [restoBottomMargin]="24"
  [tableId]="'table-grid-simplest-example'"
  [columnDefs]="columnDefs"
  [tableExpanded]="false"
  [tableData]="tableData"
  [dataTree]="false"
  [rowHeight]="48"
  [height]="'500px'"
  [movableColumns]="true"
  (cellClicked)="onCellClicked($event)"
  (tableInstanceChange)="tableInstanceChange($event)"
></resto-table-grid>
